import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
  IconButton,
  Box,
} from "@mui/material";
import { Visibility, Delete } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { ICarWashObject } from "../../../../../types/carWash";
import { useRole } from "../../../../../context/RoleContext";

interface CarWashesTableProps {
  carWashes: ICarWashObject[];
  onView: (carWashId: string) => void;
  onDelete: (carWash: ICarWashObject) => void;
}

const CarWashesTable = ({
  carWashes,
  onView,
  onDelete,
}: CarWashesTableProps) => {
  const { isSuperAdmin } = useRole();
  const { t } = useTranslation();

  const getStatusColor = (active: boolean) => {
    return active ? "success" : "error";
  };

  const getStatusLabel = (active: boolean) => {
    return active ? t("carWashTable.active") : t("carWashTable.inactive");
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t("carWashTable.legalName")}</TableCell>
            <TableCell>{t("carWashTable.location")}</TableCell>
            <TableCell>{t("carWashTable.contact")}</TableCell>
            <TableCell>{t("carWashTable.rating")}</TableCell>
            <TableCell>{t("carWashTable.images")}</TableCell>
            <TableCell>{t("carWashTable.status")}</TableCell>
            <TableCell align="right">{t("carWashTable.actions")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {carWashes.map((carWash) => (
            <TableRow key={carWash._id || Math.random()} hover>
              <TableCell>{carWash.legalName}</TableCell>
              <TableCell>
                {carWash.location?.street || (carWash.location as any)?.streetName || "N/A"}
              </TableCell>
              <TableCell>{carWash.contact?.phone || "N/A"}</TableCell>
              <TableCell>{carWash.rating?.toFixed(1) || "0.0"} / 5.0</TableCell>
              <TableCell>{t("carWashTable.photos", { count: carWash.images?.length || 0 })}</TableCell>
              <TableCell>
                <Chip
                  label={getStatusLabel(carWash.active)}
                  color={getStatusColor(carWash.active) as any}
                  size="small"
                />
              </TableCell>
              <TableCell align="right">
                <Box display="flex" gap={1} justifyContent="flex-end">
                  <IconButton
                    size="small"
                    color="primary"
                    onClick={() => carWash._id && onView(carWash._id)}
                    disabled={!carWash._id}
                  >
                    <Visibility />
                  </IconButton>
                  {isSuperAdmin && (
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => onDelete(carWash)}
                    >
                      <Delete />
                    </IconButton>
                  )}
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CarWashesTable;
